import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'next/router';
import { FacebookShareButton } from 'react-share';
import { ShareAltOutlined, CommentOutlined } from '@ant-design/icons';
import {
  getArticleByUrl,
  getAboutArticle,
  getTermsArticle,
  getCourses,
  getFeaturesArticle,
  getContactUsArticle,
  getPrivacyArticle,
  getPricingArticle,
  getOurCommunitiesArticle,
  getAddCourseIntroArticle,
} from '../../utils/directory';
import { articleVisited } from '../../utils/events/articles';
import { LocalizationContext } from '../../hoc/Localization';
import { LocationContext } from '../../hoc/Location';
import { SettingsContext } from '../../hoc/Settings';
import { RouteContext } from '../../hoc/Route';
import ArticleBody from '../../components/Blog/ArticleBody';
import Button from '../../components/Button';
import Loading from '../../components/Loading';
import Error from '../_error';
import ModalSubscribe from '../blog/modalSubscribe';
import ShareModal from '../../components/TinyComponents/ShareModal';
import styles from './styles.less';

const getArticle = async (page, blogCountry, blogLocale, url) => {
  if (page === 'about') {
    return getAboutArticle(blogCountry, blogLocale);
  }

  if (page === 'terms') {
    return getTermsArticle(blogCountry, blogLocale);
  }

  if (page === 'features') {
    return getFeaturesArticle(blogCountry, blogLocale);
  }

  if (page === 'privacy') {
    return getPrivacyArticle(blogCountry, blogLocale);
  }

  if (page === 'pricing') {
    return getPricingArticle(blogCountry, blogLocale);
  }

  if (page === 'ourCommunities') {
    return getOurCommunitiesArticle(blogCountry, blogLocale);
  }

  if (page === 'contactUs') {
    return getContactUsArticle(blogCountry, blogLocale);
  }

  if (page === 'addCourseIntro') {
    return getAddCourseIntroArticle(blogCountry, blogLocale);
  }

  if (page === 'blogLanding') {
    return getArticleByUrl(url, [blogCountry, blogLocale, 85]);
  }

  return getArticleByUrl(url, [blogCountry, blogLocale]);
};

const Article = ({ data, load, router }) => {
  const {
    domainSettings: { blogCountry, featureCommunity },
  } = React.useContext(SettingsContext);

  const {
    page,
    params: { url },
  } = React.useContext(RouteContext);

  const { t, blogLocale } = React.useContext(LocalizationContext);
  const { countries } = React.useContext(LocationContext);

  const [article, setArticle] = React.useState(data);
  const [loading, setLoading] = React.useState(load);
  const [recommended, setRecommended] = React.useState(null);
  const [currentPgae, setCurrentPage] = React.useState('');
  const [shareModalOpen, setShareModalOpen] = React.useState(false);

  React.useEffect(() => {
    if (router.query.pricing) {
      const scrollId = document.getElementById('scroll-intro');
      const reviewPosition = scrollId.getBoundingClientRect();
      window.scrollTo({ top: reviewPosition.top - 100, behavior: 'smooth' });
    }
  }, []);
  React.useEffect(() => {
    setCurrentPage(page);
    if (!load || (data && data.shortId === url)) {
      if (page === 'article') {
        articleVisited(data);
      }

      return;
    }

    setLoading(true);

    getArticle(page, blogCountry, blogLocale, url).then(res => {
      setArticle(res);
      setLoading(false);

      if (page === 'article') {
        articleVisited(res);
      }
    });
  }, [url, page, blogLocale]);

  React.useEffect(() => {
    if (article && article.recommendations) {
      (async () => {
        setRecommended(
          (
            await getCourses({
              filters: { countries, type: 'recommended' /* other filters */ },
              limit: 3,
            })
          ).data,
        );
      })();
    }
  }, [article]);

  const handleShareClicked = () => {
    setShareModalOpen(!shareModalOpen);
  };

  if (loading) {
    return <Loading full />;
  }

  if (!article) {
    return <Error />;
  }

  const title = page === 'about' ? t('meta.about.title') : null;
  const { params } = React.useContext(RouteContext);
  const {
    domainSettings: { domain },
  } = React.useContext(SettingsContext);
  const { locale } = React.useContext(LocalizationContext);
  return (
    <div className={currentPgae === 'addCourseIntro' ? styles.introPage : styles.blogArticle}>
      <ArticleBody title={title} article={article} recommended={recommended} />
      {page === 'article' && <ModalSubscribe />}
      {/* eslint-disable-next-line */}
      <button onClick={() => hello()} style={{ display: 'none' }}>
        Crash
      </button>
      {featureCommunity && !!article.communityCategories && page === 'article' && (
        <div className={styles.buttonsContainer}>
          <div className={styles.btnarticle}>
            <a
              href={`https://www.course.am/community/category/${article.communityCategories[0]}/`}
              className={styles.accept_comment}
              target="blank"
            >
              <Button size="default" type="secondary">
                <CommentOutlined />
                {t('article.comment.button')}
              </Button>
            </a>
          </div>
          <div className={styles.shareArticle}>
            <FacebookShareButton
              url={`https://${domain === 'course.am' ? `www.${domain}` : domain}/${locale}/blog/${
                params.year
              }/${params.month}/${params.day}/${params.url}`}
            >
              <Button size="default" type="secondary">
                <ShareAltOutlined />
                <span>{t('share.article')}</span>
              </Button>
            </FacebookShareButton>
            <ShareModal onCancel={handleShareClicked} visible={shareModalOpen} article={params} />
          </div>
        </div>
      )}
    </div>
  );
};

Article.propTypes = {
  load: PropTypes.bool,
  data: PropTypes.object,
  router: PropTypes.object,
};

Article.defaultProps = {
  load: false,
  data: null,
  router: {},
};

Article.getInitialProps = async (
  { res, query },
  router,
  {
    routeProps: { page },
    localizationProps: { blogLocale },
    settingsProps: {
      domainSettings: { blogCountry },
    },
  },
) => {
  if (process.browser) {
    return {
      load: true,
    };
  }

  const data = await getArticle(page, blogCountry, blogLocale, query.url);

  if (!data) {
    res.statusCode = 404;
  }

  return {
    data,
  };
};

export default withRouter(Article);
